import { InputNumber } from 'primereact/inputnumber';
import React, { useState, useEffect } from 'react';
import { v4 } from 'uuid';
import { store } from '../../../../../store/index.js';
import { getAttrValue } from '../../../../../api/propChecker.js';

const C2InputNumber = (props) => {
    const { opts } = props;
    const [value, setValue] = useState(0);
    const id = v4();
    useEffect(() => {
        // TODO: variable in variable should be implemented and this line should be deleted
        setValue(getAttrValue(opts.value, store.getState().variables));
    }, [props]);
    const handleChange = (e) => {
        setValue(e.value);
        props.onChange({ [opts.valKey]: e.value });
    };
    return React.createElement("span", { className: "field" },
        React.createElement("label", { htmlFor: id }, opts.label),
        React.createElement(InputNumber, { id: id, className: "w-full", value: value, onChange: (e) => handleChange(e) }));
};

export { C2InputNumber as default };
//# sourceMappingURL=C2InputNumber.js.map
